<template>
  <div class="presentation">
    <div class="presentation-information">
      <div class="presentation-information__title">
        <p class="presentation-information__title__name">
          {{testName}}
        </p>
        <p class="presentation-information__title__know">
          知识点数 ：{{knowledgeCount}} 个
          <span v-if="type" class="ml-30 isgreen">掌握 ： {{graspKnowledge}}</span>
          <span v-if="type" class="ml-30 isred">未掌握 ： {{notGraspKnowledge}}</span>
        </p>
      </div>
      <div class="presentation-information__change pointer">
        <div
          @click="listEchartsChange(false)"
          class="fx hover"
          :class="{'isactive': !isChartShow}"
        >列表</div>
        <div
          @click="listEchartsChange(true)"
          class="fx hover"
          :class="{'isactive': isChartShow}">图谱</div>
      </div>
    </div>
    <el-table
      v-if="!isChartShow"
      class="fx bgc"
      :data="data"
      style="width: 99%"
      height="250"
      resizable="false"
      border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="knowledge_name"
        label="知识点名称"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        sortable
        width="300"
        align="center"
        label="最新测试结果"
        >
        <template slot-scope="scope">
          <div v-if="type" :class="scope.row.is_user_grasp? 'isgreen': 'isred' ">
            {{scope.row.is_user_grasp ? '掌握' : '未掌握'}}
          </div>
          <div v-else> -- </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="chart">
      <div v-show="isChartShow" ref="container" class="presentation-chart">
        <div ref="chart" class="chart-dom pointer"></div>
      </div>
      <div v-if="isChartShow" class="chart-legend">
        <span
          v-for="(item, index) in legendList"
          :key="index">
          <span :style="{'background-color': item.color}" class="chart-legend__dot"></span>
          <span>{{item.name}}</span>
          <span v-if="index<legendList.length -1"> | </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataPresentation',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    edges: {
      type: Array,
      default: () => [],
    },
    type: {},
    testName: {
      type: String,
      default: '',
    },
    basicInfo: {
    },
  },
  data() {
    return {
      isChartShow: false,
      legendList: [{
        name: '掌握熟练',
        color: '#39D6E1',
      }, {
        name: '掌握较好',
        color: '#12ADFF',
      }, {
        name: '掌握一般',
        color: '#FFE356',
      }, {
        name: '掌握较弱',
        color: '#FE9B64',
      }, {
        name: '未掌握',
        color: '#D157F3',
      }],
      legend: [{
        name: '未学习(-1)',
        icon: 'circle',
        color: '#9EB0C8',
        textStyle: {
          color: '#9EB0C8',
        },
      }, {
        name: '掌握熟练(80~100%)',
        icon: 'circle',
        color: '#39D6E1',
        textStyle: {
          color: '#39D6E1',
        },
      }, {
        name: '掌握较好(60~79%)',
        icon: 'circle',
        color: '#12ADFF',
        textStyle: {
          color: '#12ADFF',
        },
      }, {
        name: '掌握一般(40~59%)',
        icon: 'circle',
        color: '#FFE356',
        textStyle: {
          color: '#FFE356',
        },
      }, {
        name: '掌握较弱(20~39%)',
        icon: 'circle',
        color: '#FE9B64',
        itemWidth: 50,
        itemHeight: 50,
        textStyle: {
          color: '#FE9B64',
        },
      }, {
        name: '未掌握(0~19%)',
        icon: 'circle',
        color: '#D157F3',
        textStyle: {
          color: '#D157F3',
        },
      }],
    };
  },
  watch: {
    isChartShow: {
      immediate: true,
      handler(n) {
        if (n) {
          this.$nextTick(() => {
            this.init();
          });
        }
      },
    },
    data() {
      if (this.isChartShow) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
  },
  computed: {
    knowledgeCount() {
      return this.basicInfo.knowledge_count;
    },
    graspKnowledge() {
      return this.basicInfo.grasp_knowledge;
    },
    notGraspKnowledge() {
      return this.basicInfo.not_grasp_knowledge;
    },
  },
  mounted() {
  },
  methods: {
    listEchartsChange(type) {
      this.isChartShow = type;
    },
    format(percentage) {
      return percentage === `${percentage}%`;
    },
    init() {
      console.log('init');
      this.chart = this.$echarts.init(this.$refs.chart);
      this.chart.setOption({
        color: this.legend.map((item) => item.color),
        // legend: {
        //   data: this.legend,
        // },
        legendHoverLink: true,
        series: [{
          data: this.data,
          focusNodeAdjacency: true,
          // focus: 'adjacency',
          symbolSize: 18,
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [1, 10],
          force: {
            edgeLength: 230,
            repulsion: 210,
          },
          lineStyle: {
            color: 'source',
            curveness: 0.1,
          },
          type: 'graph',
          layout: 'force',
          animation: true,
          draggable: true,
          categories: this.legend,
          edges: this.edges,
          label: {
            show: true,
            color: 'inherit',
            position: 'top',
            distance: 5,
          },
          emphasis: {
            itemStyle: {
              color: '#1989FA',
              symbolSize: 26,
              borderWidth: '2px',
              borderColor: '#1989FA',
            },
            label: {
              color: '#1989FA',
              fontSize: '16px',
            },
          },
        }],
      });
      setTimeout(() => {
        const { width, height } = this.$refs.container.getBoundingClientRect();
        const { width: iWidth, height: iHeight } = this.$refs.chart.getBoundingClientRect();
        this.$refs.container.scrollLeft = (iWidth - width) / 2;
        this.$refs.container.scrollTop = (iHeight - height) / 2;
      }, 30);
    },
  },
};
</script>

<style lang="scss" scoped>
  .presentation {
    flex: 1;
    display: flex;
    flex-direction: column;
    &-information {
      display: flex;
      height: 99px;
      &__title {
        flex: 1;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
        &__name {
          font-weight: 500;
          font-size: 16px;
          margin-top: 16px;
          margin-bottom:5px;
        }
        &__know {
        font-size: 14px;
        }
      }
      &__change {
        display: flex;
        height: 28px;
        line-height: 28px;
        width: 170px;
        margin-top: 16px;
        border-radius: 2px;
        border: 1px solid #C0C4CB;
        .fx {
          text-align: center;
          flex: 1;
        }
        .hover {
          &:hover {
          color: #0091FF;
        }
        }
      }
    }
    &-chart {
      position: relative;
      height: 378px;
      max-width: calc(100vw - 500px);
      overflow: auto;
      background: #FAFDFF;
      border: 1px solid #E6E9F0;
      .chart-dom {
        width: 150%;
        height: 750px;
        // width: 2000px;
      }
    }
    .chart {
      display: flex;
      flex-direction: column;
    }
    .chart-legend {
      flex: 1;
      align-self: center;
      margin-top: 30px;
        &__dot {
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-right: 8px;
          border-radius: 50%;
        }
      }
    /deep/ .el-progress-bar__inner{
      background-color: unset;
      background-image: linear-gradient(to left, #A6A0FF , #3383FF);
    }
  }
  .ml-10 {
    margin-left: 30px;
  }
  .isgreen {
    color: #67C23A;
  }
  .isred {
    color: #F56C6C;
  }
  .fx {
    flex: 1;
    font-size: 16px;
  }
  .bgc {
    background: #FAFDFF;
    height: 484px;
  }
  .isactive {
    background-color: #0091FF;
    color: #fff;
    &:hover {
      color: #fff !important;
    }
  }
</style>
